import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AvatarModule } from '@sag-ui';
import { IUser } from '@cod-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { UserState } from '../../../user-management/state/user-management.state';

@Component({
    selector: 'app-user',
    standalone: true,
    imports: [CommonModule, AvatarModule],
    templateUrl: './user.component.html'
})
export class UserComponent {
    protected user$?: Observable<IUser | undefined> = inject(Store).select(UserState.user);
}
